import { inject, injectable } from 'inversify';
import * as Api from '@xlearn/common';
import { MsgPackCourseFileLoader, MsgPackCourseFileLoaderSymbol } from '@/app/fetch/msgpack-course-file';
import { ResettableCancelToken, compoundCancelToken, CancelToken } from '@/app/shared/utils/cancel-token'
import { withBaseUrl } from '@/app/shared/utils/base-path';
import aspectStoreModule from '@/app/aspect/apsect-state';

// TODO: Review, it is called more than once, check why and optimize
@injectable()
export class CourseService {

  private cancelToken: ResettableCancelToken

  constructor(@inject(MsgPackCourseFileLoaderSymbol)
              private fileLoader: MsgPackCourseFileLoader) {

    this.cancelToken = new ResettableCancelToken()
  }
  
  public async getCourseId(): Promise<string> {
    if (aspectStoreModule.course !== null) {
      return aspectStoreModule.course.id;
    }

    const course = await this.getCourse();
    if (!course.success) { throw new Error('Course could not be loaded')}
    return course.value.id;
  }

  public async getCourse() {

    // cancel previous load
    const token = this.cancelToken.cancelAndReset();
    const loadResult = await this.fileLoader.load<Api.SerializedCourse>(withBaseUrl('index.dat'), token)

    return loadResult
  }
}

export const CourseServiceSymbol = Symbol.for('CourseService');
